'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundError = void 0;
var tslib_1 = require("tslib");
var genericError_js_1 = require("./genericError.js");
/**
 * Ошибка "Ничего не найдено".
 *
 * @example
 *
 * function foo(params) {
 *    if (!('bar' in params)) {
 *      throw new NotFoundError({
 *        message: 'Bar not Found!', domain: 'foo()',
 *      });
 *    }
 * }
 *
 * @export
 * @class NotFoundError
 * @extends {GenericError}
 */
var NotFoundError = /** @class */ (function (_super) {
    tslib_1.__extends(NotFoundError, _super);
    function NotFoundError(_a) {
        var message = _a.message, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, {
            type: 'NotFoundError',
            message: message,
            domain: domain,
            details: details,
        }) || this;
        Object.setPrototypeOf(_this, NotFoundError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, NotFoundError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return NotFoundError;
}(genericError_js_1.GenericError));
exports.NotFoundError = NotFoundError;
//# sourceMappingURL=notFoundError.js.map
